import { createSelector } from '@reduxjs/toolkit';

export const reportsSelector = (state: ReduxState) => state.reportsReducer;
export const selectCurrentReport = createSelector(reportsSelector, (reports) => reports?.currentReport);
